import liveCapture from './zoho-live-all-groups.json';

// Captured from Zoho's live subject picker (#cmpemoji_list) on 2026-09.
// Empty navigation entries are deliberately ignored; item order and duplicates
// are retained exactly as captured.
export const ZOHO_SUBJECT_EMOJI_ALLOWLIST_VERSION = 'zoho-live-twemoji14-2026-09';

export const ZOHO_SUBJECT_EMOJI_GROUPS = liveCapture.groups.map(group => ({
  label: group.label,
  items: group.items.filter(item => item && item.value).map(item => ({ value: item.value, marker: item.marker, file: item.file }))
}));

export const ZOHO_SUBJECT_EMOJI_CATEGORIES = ZOHO_SUBJECT_EMOJI_GROUPS.reduce((all, group, index) => {
  all[`group${index + 1}`] = group.items;
  return all;
}, {});

export const ZOHO_SUBJECT_EMOJI_CATEGORY_ITEMS = ZOHO_SUBJECT_EMOJI_CATEGORIES;
export const ZOHO_SUBJECT_EMOJI_ALLOWLIST = ZOHO_SUBJECT_EMOJI_GROUPS.reduce((all, group) => all.concat(group.items), []);
